import { Injectable } from "@angular/core";
import moment from "moment-timezone";

@Injectable({
  providedIn: "root",
})
export class DatesService {
  constructor() {}

  getStringDate(): string {
    return moment().tz("America/Santo_Domingo").format("YYYY-MM-DD");
  }

  getStringDateFromDate(date: Date | string): string {
    if (!date) {
      return null;
    }

    return moment(date).tz("America/Santo_Domingo").format("YYYY-MM-DD");
  }

  getStringDateTime(): string {
    return moment().tz("America/Santo_Domingo").format("YYYY-MM-DD HH:mm:ss");
  }

  getStringDateTimeFromDate(date: Date | string): string {
    if (!date) {
      return null;
    }

    return moment(date)
      .tz("America/Santo_Domingo")
      .format("YYYY-MM-DD HH:mm:ss");
  }

  getStringDateTimeUTC(): string {
    return moment().tz("UTC").format("YYYY-MM-DD HH:mm:ss");
  }

  getDateTime(): Date {
    return moment().tz("America/Santo_Domingo").toDate();
  }

  getDateFromString(date: string): Date {
    if (!date) {
      return null;
    }
    return moment(date).tz("America/Santo_Domingo").toDate();
  }
}
